import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const OrderitemsEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		bookingid: yup.string().required().label("Bookingid"),
		itemtype: yup.string().required().label("Itemtype"),
		itemcategory: yup.string().nullable().label("Itemcategory"),
		quantity: yup.number().required().label("Quantity"),
		unitweight: yup.number().nullable().label("Unitweight"),
		unitprice: yup.number().required().label("Unitprice"),
		instructions: yup.string().nullable().label("Instructions"),
		totalprice: yup.number().required().label("Totalprice"),
		createdat: yup.string().nullable().label("Createdat"),
		treatment: yup.string().nullable().label("Treatment")
	});
	// form default values
	const formDefaultValues = {
		bookingid: '', 
		itemtype: '', 
		itemcategory: '', 
		quantity: "((1))", 
		unitweight: '', 
		unitprice: '', 
		instructions: '', 
		totalprice: '', 
		createdat: "(getdate())", 
		treatment: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/orderitems`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="OrderitemsEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Orderitem"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Bookingid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/bookingid_option_list_3"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="bookingid"     optionLabel="label" optionValue="value" value={formik.values.bookingid} onChange={formik.handleChange} options={response} label="Bookingid"  placeholder="Select a value ..." filter={true} className={inputClassName(formik?.errors?.bookingid)}   />
                                                    <ErrorMessage name="bookingid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Itemtype *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/itemtype_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="itemtype"     optionLabel="label" optionValue="value" value={formik.values.itemtype} onChange={formik.handleChange} options={response} label="Itemtype"  placeholder="Select a value ..." filter={true} className={inputClassName(formik?.errors?.itemtype)}   />
                                                    <ErrorMessage name="itemtype" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Itemcategory 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/category_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="itemcategory"     optionLabel="label" optionValue="value" value={formik.values.itemcategory} onChange={formik.handleChange} options={response} label="Itemcategory"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.itemcategory)}   />
                                                    <ErrorMessage name="itemcategory" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Quantity *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="quantity"  onChange={formik.handleChange}  value={formik.values.quantity}   label="Quantity" type="number" placeholder="Enter Quantity"  min={0}  step="any"    className={inputClassName(formik?.errors?.quantity)} />
                                                <ErrorMessage name="quantity" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Unitweight 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="unitweight"  onChange={formik.handleChange}  value={formik.values.unitweight}   label="Unitweight" type="number" placeholder="Enter Unitweight"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.unitweight)} />
                                                <ErrorMessage name="unitweight" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Unitprice *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="unitprice"  onChange={formik.handleChange}  value={formik.values.unitprice}   label="Unitprice" type="number" placeholder="Enter Unitprice"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.unitprice)} />
                                                <ErrorMessage name="unitprice" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Instructions 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="instructions"  onChange={formik.handleChange}  value={formik.values.instructions}   label="Instructions" type="text" placeholder="Enter Instructions"        className={inputClassName(formik?.errors?.instructions)} />
                                                <ErrorMessage name="instructions" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Totalprice *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalprice"  onChange={formik.handleChange}  value={formik.values.totalprice}   label="Totalprice" type="number" placeholder="Enter Totalprice"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.totalprice)} />
                                                <ErrorMessage name="totalprice" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Treatment 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/treatment_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="treatment"     optionLabel="label" optionValue="value" value={formik.values.treatment} onChange={formik.handleChange} options={response} label="Treatment"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.treatment)}   />
                                                    <ErrorMessage name="treatment" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
OrderitemsEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'orderitems',
	apiPath: 'orderitems/edit',
	routeName: 'orderitemsedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default OrderitemsEditPage;
